export default function inViewport(el, margin = 0) {
  const $element = (el instanceof jQuery) ? el : jQuery(el);
  const elementTop = $element.offset().top + margin;
  const elementBottom = elementTop + $element.outerHeight() - margin;
  const viewportTop = jQuery(window).scrollTop();
  const viewportBottom = viewportTop + jQuery(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}
